module.exports = __webpack_public_path__ + "static/media/resource.18ac0c0d.svg";